<template>
    <transition name="fade">
      <div v-if="visible" class="message-toast" :class="typeClass">
        {{ message }}
      </div>
    </transition>
  </template>
   
  <script>
  export default {
    data() {
      return {
        visible: false,
        message: '',
        type: 'error', // 可以是 info, success, warning, error
      };
    },
    computed: {
      typeClass() {
        return `message-toast--${this.type}`;
      }
    },
    methods: {
      show(message, type = 'error', duration = 3000) {
        this.message = message;
        this.type = type;
        this.visible = true;
        setTimeout(() => {
          this.visible = false;
        }, duration);
      }
    }
  };
  </script>
   
  <style scoped>
  .message-toast {
    position: fixed;
    left: 50%;
    top: 100px;
    transform: translateX(-50%);
    padding: 10px 20px;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.7);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    z-index: 9999;
    transition: opacity 0.3s ease;
  }
   
  .message-toast--info {
    color: #333; /* 信息提示颜色 */
  }
  .message-toast--success {
    color: #4caf50; /* 成功提示颜色 */
  }
  .message-toast--warning {
    color: #ff9800; /* 警告提示颜色 */
  }
  .message-toast--error {
    /* color: #f44336; 错误提示颜色 */
    color: #FFFFFF;
  }
   
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
  }
  </style>